import React, {useEffect, useState} from 'react'
import { Table, Button } from 'antd'

import EditableCell from './EditableCell'
import { EditableRow } from './EditableCell'
import { editTableDataSalary } from 'store/actions/salary'
import { useActions } from '../../hooks/useActions'

import { connect } from 'react-redux'

import './index.scss'

import { AddIco, RemoveIco,NextIco, PrevIco } from '../../../modules/CustomIcons'
import PopConfirm from 'components/PopConfirm'
import { useTranslation } from 'react-i18next'

const TableComponent: React.FC<any> = (props) => {
  const {t} = useTranslation()
  const { editTableDataSalary } = useActions()
  const [selectedRowKeys, setCheckedList] = useState([])
  const [rows, setColumns] = useState(props.data)
  const [visible, setVisible] = useState(false)

  const table_class=props.className || '';

  useEffect(() => {

    setColumns(() => props.data);

    document.querySelector('.ant-table-measure-row')?.remove();

    // setTimeout(() => {
    //   document.querySelector('.ant-table-expanded-row-fixed')?.remove();

    // }, 100)

  }, [props.data]);

  // const handleRemoveRow = () => {
  //   const removedArr = rows.filter(
  //     (item: number) => !selectedRowKeys.includes(item.key)
  //   )
  //   setColumns(removedArr)
  // }

  function onSelectChange(checkedList: Array<String>) {
    setCheckedList(checkedList)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: props.getCheckboxProps
  }
  const handleSave = (row:any) => {
    props.handleInputChangeSave(row)
    // const newData = [...rows]    
    // const index = newData.findIndex((item) => row.key === item.key)
    // const item = newData[index]
    // newData.splice(index, 1, { ...item, ...row })
    // editTableDataSalary(newData)    
    // setColumns(newData)
  }

  const handleInputChange = (value:string, dataIndex:string) => {
     props.handleInputChange(value, dataIndex)
  }

  const itemRenderPagination = (current, type, originalElement) => {
      if (type === 'prev') {
        return <div className='page-nav'><PrevIco/></div>;
      }
      if (type === 'next') {
        return <div className='page-nav'><NextIco/></div>;
      }
      return originalElement;
    }

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  }

  const columnsData = props.columns.map((col: any) => {
    if (!col.editable) {
      return col
    }
    return {
      ...col,
      onCell: (record: any) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave,
        onPaste: props.onPaste,
        readOnly: props.readOnly,
        placeholder: col.placeholder,
        disabled: props.disabledInput,
        // handleSaveTest: handleSave
        handleInputChange: handleInputChange
      }),
    }
  })
  return (
    <div className={props.tableWrapperClass} style={props.tableWrapperStyle}>
      <Table
          components={components}
          dataSource={rows}
          columns={columnsData}
          id={props.id}
          title={props.title || false}
          className={` table-striped table-hover table table-responsive add_salary_account_table ${table_class} ${rows && rows.length == 0 ? 'empty-table' : ''}`}
          rowSelection={props.rowSelection ? props.rowSelection : false}
          sticky={props.sticky || false}
          // rowSelection={rowSelection}
          showSorterTooltip={false}
          // handleInputChange={handleInputChange}
          onChange={props.onChange}
          onRow={props.onRow}
          onExpand={props.onExpand}
          expandedRowKeys={props.expandedRowKeys}
          expandRowByClick={props.expandRowByClick || false}
          onCell={props.onCell}
          expandedRowClassName={props.expandedRowClassName}
          onHeaderRow={props.onHeaderRow}
          tableLayout={props.tableLayout}
          showSizeChanger={false}
          scroll={props.scroll}
          hideOnSinglePage={true}
          expandIconColumnIndex={props.expandIconColumnIndex}
          summary={props.summary}
          pagination={props.pagination ?
              {
                className: props?.paginationClassName, 
                pageSize: props.pageSize, 
                position: props.position,
                alignment: props.alignment,
                onChange: props.onPageChange,
                current: props.current ? props.current : 1,
                itemRender: (current, type, originalElement) => itemRenderPagination(current, type, originalElement)
              } : false
            }
          // pagination={{
          //   itemRender:(current, type, originalElement)=>itemRenderPagination(current, type, originalElement),
          //   showQuickJumper: true
          //   }}
          rowClassName={props.rowClassName || 'ps-pointer editable-row'}
          style={{cursor: 'pointer'}}
          loading={props.loading || false}
          expandable={props?.expandable}
          // scroll={{x:1000}}
      />
      {props.editableRows && (
        <ul className="flex add-remove-btns">
          <li>
            <Button
              icon={<AddIco />}
              disabled={props.disableAdd}
              onClick={props.handleAddRow}
              className="add_btn"
            >
              {t("salary.addRow")}
            </Button>
          </li>
          <li>
            <PopConfirm
              handleRemoveRow={props.handleRemoveRow}
              closeModal={() => setVisible(false)}
              visible={visible}
              // handlePop={() => setPopVisible(!popVisibility)}
              >
              
              </PopConfirm>
              <Button
                icon={<RemoveIco />}
                disabled={props.disableRemove}
                className="remove_btn"
                onClick={() => setVisible(true)}
              >
                {t("salary.deleteRowManual")}
              </Button>
          </li>
        </ul>
      )}
    </div>
  )
}
// export default TableComponent

const mapDispatchToProps = { editTableDataSalary }

export default connect(null, mapDispatchToProps)(TableComponent)
